module.exports = __webpack_public_path__ + "static/media/Chemical dosing points.365b5116.pdf";